import { useState } from 'react';
import { useAuth } from '../../../shared/useAuth.js';
import { apiError } from '../../../shared/api.js';

export function useLogin() {
  const login = useAuth((s) => s.login);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submit = async ({ username, password, company }) => {
    setLoading(true);
    setError(null);
    try {
      const data = await login(username, password, company);
      setLoading(false);
      return { ok: true, data };
    } catch (err) {
      setLoading(false);
      const status = err?.response?.status;
      const code = err?.response?.data?.error?.code;
      // الخادم يطلب كود الشركة (تنصيب فيه أكثر من شركة) — نُظهر الحقل.
      if (code === 'COMPANY_REQUIRED') {
        const message = 'هذا الخادم يخدم أكثر من شركة — أدخل كود شركتك';
        setError(message);
        return { ok: false, error: message, status, code };
      }
      const message =
        code === 'COMPANY_SUSPENDED' || code === 'COMPANY_NOT_ACTIVE'
          ? apiError(err)
          : (status === 401
            ? 'اسم المستخدم أو كلمة المرور غير صحيحة'
            : apiError(err) || 'تعذر تسجيل الدخول');
      setError(message);
      return { ok: false, error: message, status, code };
    }
  };

  return { submit, loading, error, reset: () => setError(null) };
}
